import { Link, useParams } from "react-router-dom";
import { HelpCircle } from "lucide-react";
import type { Article, Category } from "@core/features/support";
import { Type } from "@themes/pollinator/ui/Type";
import { Button } from "@themes/pollinator/ui/Button";

export type Props = {
  category: Category;
};

export function SupportRecommendedArticleGroup({ category }: Props) {
  const { id: programId } = useParams<{ id: string }>();
  // Get all articles from this category and its subcategories
  const getAllArticles = (cat: Category): Article[] => {
    const articles = [...cat.articles];
    cat.subcategories.forEach((subcat) => {
      articles.push(...getAllArticles(subcat));
    });
    return articles;
  };

  const articles = getAllArticles(category);

  return (
    <div className="flex flex-col gap-4">
      <Type as="h3" variant="h5" className="text-brand-700">
        {category.name}
      </Type>
      <div className="flex flex-col items-start relative -left-3">
        {articles.slice(0, 5).map((article) => (
          <Button
            as={Link}
            key={article.id}
            to={`/program/${programId}/support/${article.id}`}
            variant="ghost"
            iconComponent={HelpCircle}
            typeClassName="max-w-64 truncate"
            data-testid={`support-recommended-article-${article.id}`}
          >
            {article.title}
          </Button>
        ))}
      </div>
    </div>
  );
}

export default SupportRecommendedArticleGroup;

